import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSmoothing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 13.25C19.5 13.8023 19.0523 14.25 18.5 14.25C17.9477 14.25 17.5 13.8023 17.5 13.25C17.5 12.6977 17.9477 12.25 18.5 12.25C19.0523 12.25 19.5 12.6977 19.5 13.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 14.25C16.0523 14.25 16.5 13.8023 16.5 13.25C16.5 12.6977 16.0523 12.25 15.5 12.25C14.9477 12.25 14.5 12.6977 14.5 13.25C14.5 13.8023 14.9477 14.25 15.5 14.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.75 5.25C10.75 4.00736 11.7574 3 13 3H17C17.9797 3 18.8131 3.62611 19.122 4.5H19.5C21.0188 4.5 22.25 5.73122 22.25 7.25V18.25C22.25 19.7688 21.0188 21 19.5 21H2.5C2.08579 21 1.75 20.6642 1.75 20.25C1.75 14.3129 6.56294 9.5 12.5 9.5H20.75V7.25C20.75 6.55964 20.1904 6 19.5 6H19.122C18.8131 6.87389 17.9797 7.5 17 7.5H13C11.7574 7.5 10.75 6.49264 10.75 5.25ZM13 4.5C12.5858 4.5 12.25 4.83579 12.25 5.25C12.25 5.66421 12.5858 6 13 6H17C17.4142 6 17.75 5.66421 17.75 5.25C17.75 4.83579 17.4142 4.5 17 4.5H13ZM20.75 11H12.5C9.12805 11 6.17751 12.8042 4.56111 15.5H20.75V11ZM20.75 17H3.83707C3.54134 17.7879 3.35003 18.6268 3.27997 19.5H19.5C20.1904 19.5 20.75 18.9404 20.75 18.25V17Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconSmoothing as ReactComponent };
